import { useGetOne } from 'react-admin';
import { DrawerLink } from './DrawerLink';
import PropTypes from 'prop-types';

export const DrawerLinkWithData = ({ record, source, resource, labelField = 'name', action = 'show', sx = {}, relative = false }) => {
    const { data, isLoading } = useGetOne(resource, { id: record[source] }, { enabled: !!record[source] });

    if (isLoading || !data) return null;

    return <DrawerLink resource={resource} action={action} source={record[source]} label={data[labelField] || ''} sx={sx} relative={relative} />;
};

DrawerLinkWithData.propTypes = {
    record: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
    labelField: PropTypes.string,
    action: PropTypes.oneOf(['show', 'edit']),
    sx: PropTypes.object,
    relative: PropTypes.bool,
};
